import { component } from 'tsdi';

type Param = 'tokenization' | 'redirectResult' | 'identityToken';

@component
export class UrlStore {
    private get location() {
        return location;
    }

    private get history() {
        return history;
    }

    private get queryParams() {
        return new URLSearchParams(this.location.search.replace(/(^\?)/g, ''));
    }

    private replaceSearch = (search: string) => {
        let newUrl = this.location.href.replace(/\?.*/, '');
        if (search) {
            newUrl += `?${search}`;
        }
        this.history.replaceState(null, '', newUrl);
    };

    public getQueryParam = (name: Param) => {
        const { queryParams } = this;
        return queryParams.get(name);
    };

    public setQueryParam = (name: Param, value: string) => {
        const { queryParams } = this;
        queryParams.set(name, value);
        this.replaceSearch(queryParams.toString());
    };

    public omitQueryParam = (name: Param) => {
        const { queryParams } = this;
        queryParams.delete(name);
        this.replaceSearch(queryParams.toString());
    };

    public getCreditCardParams() {
        const tokenization = this.getQueryParam('tokenization');
        const redirectResult = this.getQueryParam('redirectResult');
        if (tokenization && redirectResult) {
            return { tokenization, redirectResult };
        }

        return undefined;
    }

    public omitCreditCardParams() {
        this.omitQueryParam('tokenization');
        this.omitQueryParam('redirectResult');
    }
}
